import React from 'react'
import {Capacitacion} from "../components/lineamientos/Capacitacion";

export const CapacitacitacionPage = () => {
    return (
        <div>
            <Capacitacion/>
        </div>
    )
}
